import { ContentfulClpEmailCapture } from "@outschool/gql-backend-generated";
import {
  GetContentfulEmailCaptureQuery,
  GetContentfulEmailCaptureQueryVariables,
} from "@outschool/gql-frontend-generated";
import { useQueryWithPreviousData } from "@outschool/ui-apollo";
import { useSession } from "@outschool/ui-auth";
import { IterableEmailCaptureBox } from "@outschool/ui-components-website";
import { Container } from "@outschool/ui-legacy-component-library";
import React from "react";

import { isProduction } from "../../shared/Env";
import { ContentfulEmailCaptureQuery } from "../queries/ContentfulEmailCaptureQuery";

export default function IterableEmailCaptureContentfulBox({
  sx = {},
  categorySlug,
}: $TSFixMe) {
  const { isLoggedIn } = useSession();

  const { loading, data, error } = useQueryWithPreviousData<
    GetContentfulEmailCaptureQuery,
    GetContentfulEmailCaptureQueryVariables
  >(ContentfulEmailCaptureQuery, {
    skip: !categorySlug,
    variables: { categorySlug },
  });

  if (error) {
    OsPlatform.captureError(error);
  }

  if (!isLoggedIn && !loading && !error && data) {
    const contentfulData =
      (data.contentfulClpEmailCaptureCollection
        ?.items[0] as ContentfulClpEmailCapture) ?? null;

    if (contentfulData && contentfulData?.prodIterableAudienceId) {
      return (
        <Container>
          <IterableEmailCaptureBox
            sx={sx}
            contentfulData={contentfulData}
            isProduction={isProduction}
          />
        </Container>
      );
    }
  }

  return null;
}
